import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

// manor
import { Typography } from '@comparethemarketau/manor-typography';
import { Button } from '@comparethemarketau/manor-button';
import { Input } from '@comparethemarketau/manor-input';
import { Link } from '@comparethemarketau/manor-link';
import { ManorContext } from '@comparethemarketau/manor-provider';

import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import { applicantFirstName } from '../../../../core/state_selectors';
import { validatorEval } from '../../../../../ctm-vertical-base/base/rules';

import { CallBackSuccess } from '../common/call_back_success';
import { CallBackFailure } from '../common/call_back_failure';
import { LoadingSpinnerCircular } from '../common/loading_spinner_circular';

const useStyles = createUseStyles((theme) => ({
    container: {
        marginTop: theme.spacing[24],
        marginBottom: theme.spacing[24]
    },
    title: {
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.grey900,
        fontSize: theme.fontSize.xl,
        marginBottom: '1rem'
    },
    subTitle: {
        fontWeight: theme.fontWeight.sm,
        color: theme.colors.grey700,
        fontSize: theme.fontSize.base,
        marginBottom: '1.9rem'
    },
    inputsContainer: ({ isDesktop }) => (
        isDesktop && {
            width: '30rem'
        }
    ),
    buttonContainer: ({ isDesktop }) => (
        isDesktop && {
            width: '20rem'
        }
    ),
    inputLabelContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    }
}));

const _CallBackForm = (props) => {
    const { productId, firstNameFromApplicant, providerName, applicantMobile, applicantPhone,
        submitCallMeBack, setCallMeBackName, setCallMeBackPhone, setCallMeBackMobile, setCallMeBackIfUseOtherNumber,
        stagedName, stagedMobile, stagedPhone, stagedUseOtherNumber, callBackSuccess } = props;

    const theme = useContext(ThemeContext);
    const { isDesktop } = useContext(ManorContext);
    const classes = useStyles({ theme, isDesktop });

    const [loading, setLoading] = useState(false);
    const [failure, setFailure] = useState(false);

    // init
    useEffect(() => {
        if (!stagedName && firstNameFromApplicant) {
            setCallMeBackName(firstNameFromApplicant);
        }
        if (!stagedMobile && applicantMobile) {
            setCallMeBackMobile(applicantMobile);
        }
        if (!stagedPhone && applicantPhone) {
            setCallMeBackPhone(applicantPhone);
        }
    }, []);

    // mobile
    const [mobileValidationMessage, setMobileValidationMessage] = useState();
    const [mobileValue, setMobileValue] = useState();
    const [mobileInstantCheck, setMobileInstantCheck] = useState(false);
    const handleMobileChange = (newValue) => {
        const cleanup = newValue.replaceAll(' ', '').trim();
        setMobileValue(cleanup);
        if (mobileInstantCheck) {
            checkMobileInput(cleanup);
        }
    };
    const handleMobileBlur = () => {
        if (!mobileValue || mobileValue.length === 0) {
            return;
        }
        if (!mobileInstantCheck) {
            setMobileInstantCheck(true);
            checkMobileInput(mobileValue);
        }
    };
    const checkMobileInput = (value) => {
        if (validatorEval(value, ['isMobilePhone', ['en-AU']])) {
            if (stagedMobile !== value) {
                setCallMeBackMobile(value);
            }
            setMobileValidationMessage('');
        } else {
            setMobileValidationMessage('Please enter the mobile number in the format 04xx xxx xxx');
        }
    };

    // landline
    const [landlineValidationMessage, setLandlineValidationMessage] = useState();
    const [landlineValue, setlandlineValue] = useState();
    const [landlineInstantCheck, setLandlineInstantCheck] = useState(false);
    const handleLandlineChange = (newValue) => {
        const cleanup = newValue.replaceAll(' ', '').trim();
        setlandlineValue(cleanup);
        if (landlineInstantCheck) {
            checkLandlineInput(cleanup);
        }
    };
    const handleLandlineBlur = () => {
        if (!landlineValue || landlineValue.length === 0) {
            return;
        }
        if (!landlineInstantCheck) {
            setLandlineInstantCheck(true);
            checkLandlineInput(landlineValue);
        }
    };
    const checkLandlineInput = (value) => {
        // number = 10, two bracks = 2
        if (value && value.length === 12) {
            if (stagedPhone !== value) {
                setCallMeBackPhone(value);
            }
            setCallMeBackPhone(value);
            setLandlineValidationMessage('');
        } else {
            setLandlineValidationMessage('Please enter the landline number in the format (0x) xxxx xxxx');
        }
    };

    const [nameValidationMessage, setNameValidationMessage] = useState();
    const namePattern = /^[a-zA-Z-' ]+$/;
    const handleNameChange = (newValue) => {
        if (namePattern.test(newValue.trim())) {
            setCallMeBackName(newValue.trim());
            setNameValidationMessage('');
        } else {
            setNameValidationMessage(nameInvalidValidationMessage);
        }
    };

    const handleContactSwitch = (e) => {
        e.preventDefault();
        setCallMeBackIfUseOtherNumber(!stagedUseOtherNumber);
    };

    // temporary 20s timeout
    useEffect(() => {
        let loadingTimeout;
        if (loading) {
            loadingTimeout = setTimeout(() => {
                setLoading(false);
                if (!callBackSuccess) {
                    setFailure(true);
                }
            }, 20000);
        }
        return () => {
            if (loadingTimeout) {
                clearTimeout(loadingTimeout);
            }
            setFailure(false);
            setLoading(false);
        };
    }, [loading]);

    const handleSubmit = () => {
        if (!stagedName) {
            setNameValidationMessage('Please enter your name.');
            return;
        }

        if (stagedUseOtherNumber) {
            if (!stagedPhone) {
                setLandlineValidationMessage('Please enter your land line number');
                return;
            }
        } else if (!stagedMobile) {
            setMobileValidationMessage('Please enter your mobile number');
            return;
        }
        setNameValidationMessage('');
        setMobileValidationMessage('');
        setLandlineValidationMessage('');
        submitCallMeBack(productId);

        setFailure(false);
        setLoading(true);
    };

    if (callBackSuccess) {
        return (
            <div className={classNames('test-policyProductCard-getInTouch-callBackForm', classes.container)}>
                <CallBackSuccess name={stagedName} providerName={providerName} />
            </div>
        );
    }

    return (
        <div className={classNames('test-policyProductCard-getInTouch-callBackForm', classes.container)}>
            <Typography className={classes.title}>{'Request a call back'}</Typography>
            <Typography className={classes.subTitle}>{`Leave your details here, and a ${providerName} specialist will call you back.`}</Typography>
            <div className={classes.inputsContainer}>
                <Input
                    trackingLabel="Name for call back form"
                    label="Name"
                    id="call-me-back-name"
                    tooltip={null}
                    placeholder="Your name"
                    type="text"
                    required
                    guide={false}
                    maxLength={50}
                    disableClearIcon
                    disabled={false}
                    invalid={false}
                    prefillValue={ stagedName }
                    handleChange={handleNameChange}
                    validationMessage={nameValidationMessage}
                />
                {
                    stagedUseOtherNumber
                        ? (
                            <Input
                                id="call-me-back-landline-number"
                                trackingLabel="Landline number for call back form"
                                label={(
                                    <div className={classes.inputLabelContainer}>
                                        <Typography>Landline number</Typography>
                                        <Link trackingLabel="switch to mobile number input" underline="none" handleClick={handleContactSwitch}>Mobile number?</Link>
                                    </div>
                                )}
                                tooltip={null}
                                placeholder="(0x) 0000 0000"
                                mask={['(', /[0]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]}
                                type="text"
                                required
                                guide={false}
                                disableClearIcon
                                disabled={false}
                                invalid={false}
                                prefillValue={stagedPhone}
                                value={landlineValue}
                                handleChange={handleLandlineChange}
                                handleBlur={handleLandlineBlur}
                                validationMessage={landlineValidationMessage}
                            />
                        )
                        : (
                            <Input
                                id="call-me-back-mobile-number"
                                trackingLabel="Mobile number for call back form"
                                label={(
                                    <div className={classes.inputLabelContainer}>
                                        <Typography>Your mobile number</Typography>
                                        <Link trackingLabel="switch to land line number input" underline="none" handleClick={handleContactSwitch}>Other number?</Link>
                                    </div>
                                )}
                                tooltip={null}
                                placeholder="04xx xxx xxx"
                                mask={[/[0]/, /[4]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/]}
                                type="text"
                                required
                                guide={false}
                                disableClearIcon
                                disabled={false}
                                invalid={false}
                                prefillValue={stagedMobile}
                                value={mobileValue}
                                handleChange={handleMobileChange}
                                handleBlur={handleMobileBlur}
                                validationMessage={mobileValidationMessage}
                            />
                        )
                }
            </div>
            <div className={classes.buttonContainer}>
                <Button
                    trackingLabel={'Request call back button'}
                    variant="primary"
                    handleClick={handleSubmit}
                    disabled={loading}
                >
                    Request a call
                </Button>
            </div>
            {
                loading && <LoadingSpinnerCircular />
            }
            {
                !loading && failure && <CallBackFailure />
            }
        </div>
    );
};

_CallBackForm.propTypes = {
    productId: PropTypes.string.isRequired,
    providerName: PropTypes.string,
    // from store
    firstNameFromApplicant: PropTypes.string,
    applicantMobile: PropTypes.string,
    applicantPhone: PropTypes.string,

    stagedName: PropTypes.string,
    stagedMobile: PropTypes.string,
    stagedPhone: PropTypes.string,
    stagedUseOtherNumber: PropTypes.bool,
    callBackSuccess: PropTypes.bool,

    submitCallMeBack: PropTypes.func,
    setCallMeBackName: PropTypes.func,
    setCallMeBackPhone: PropTypes.func,
    setCallMeBackMobile: PropTypes.func,
    setCallMeBackIfUseOtherNumber: PropTypes.func
};

const mapStateToProps = (state) => {
    const stagedName = state.getIn(['vertical', 'callMeBack', 'form', 'name']);
    const stagedMobile = state.getIn(['vertical', 'callMeBack', 'form', 'mobile']);
    const stagedPhone = state.getIn(['vertical', 'callMeBack', 'form', 'phone']);
    const stagedUseOtherNumber = state.getIn(['vertical', 'callMeBack', 'form', 'helpers', 'useOtherNumber']) === 'Y';
    // identifier": "isCallBackSuccess" from rules_schema.json
    const callBackSuccess = state.getIn(['page', 'callBackSuccess']);
    return {
        stagedName,
        stagedMobile,
        stagedPhone,
        stagedUseOtherNumber,
        firstNameFromApplicant: applicantFirstName({ state }),
        applicantMobile: quoteFormSelector(state).getIn(['applicant', 'mobile']),
        applicantPhone: quoteFormSelector(state).getIn(['applicant', 'phone']),
        callBackSuccess
    };
};

/**
 * Request URL: https://dev.comparethemarket.com.au/api/car-journey/event
 * Previouse implemention:
 *  packages/ctm-vertical-car/schemas/form/call_me_back_form_schema.json
 * Rendering by =>
 *  packages/ctm-components/components/form/submit_button/submit_button.js
 * Catching on CALL_ME_BACK by
 *  packages/ctm-app/client/sagas/root_saga.js
 *      Payload loader getLeadPayload from packages/ctm-app/client/sagas/state_selectors.js
 *      Request sender validateAndSubmit from packages/ctm-app/client/sagas/validate_and_submit.js
 * Requesting by apiAction
 *  packages/ctm-util-functions/lib/api.js
 *
 * SET_VALUE
 * vertical.callMeBack.form.name
 * vertical.callMeBack.form.helpers.useOtherNumber
 * vertical.callMeBack.form.mobile
 * vertical.callMeBack.form.phone
 *
 * @param {Object} dispatch redusx dispatch
 * @returns {functions} The functions use for update redux
 */
const mapDispatchToProps = (dispatch) => {
    return {
        submitCallMeBack: (productId) => {
            dispatch({
                type: 'VALIDATE_AND_SUBMIT',
                pageName: 'callMeBack',
                apiSchema: {
                    url: '/event',
                    type: 'POST',
                    requestAction: 'CALL_ME_BACK',
                    failureType: 'non-fatal',
                    requestPayload: 'lead',
                    extraPayload: {
                        productId: 'product.productMeta.id'
                    },
                    responseActions: [
                        {
                            type: 'SET_PAGE_VALUE',
                            identifier: 'callBackSuccess',
                            value: true
                        }
                    ]
                },
                stateKey: 'vertical.callMeBack',
                requestPayload: {
                    productId
                }
            });
        },
        setCallMeBackName: (firstName) => {
            dispatch({
                type: 'SET_VALUE',
                identifier: 'name',
                stateKey: 'vertical.callMeBack',
                value: firstName
            });
        },
        setCallMeBackPhone: (phone) => {
            dispatch({
                type: 'SET_VALUE',
                identifier: 'phone',
                stateKey: 'vertical.callMeBack',
                value: phone
            });
        },
        setCallMeBackMobile: (mobile) => {
            dispatch({
                type: 'SET_VALUE',
                identifier: 'mobile',
                stateKey: 'vertical.callMeBack',
                value: mobile
            });
        },
        setCallMeBackIfUseOtherNumber: (isUseOtherNumber) => {
            dispatch({
                type: 'SET_VALUE',
                identifier: 'helpers.useOtherNumber',
                stateKey: 'vertical.callMeBack',
                value: isUseOtherNumber ? 'Y' : 'N'
            });
        }
    };
};

const CallBackForm = connect(mapStateToProps, mapDispatchToProps)(_CallBackForm);

export { CallBackForm };

// eslint-disable-next-line max-len
const nameInvalidValidationMessage = 'Please enter alphabetic characters only. International alphabetic characters, numbers and symbols are not supported by many of our partners at this time.';
